export class GameAnswers {
  imageUrl: string;
  bookId: number;
  capId: number;
  make: string;
  model: string;
  hasPlayed: boolean;
  attempts: number;
  points: number;
  winner: boolean;
}